<script>
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'

export default {
  setup() {
    return {
      locale: zhCn,
    }
  },
  computed: {
    darkMode() {
      return this.$store.getters.darkMode
    },
  },
  watch: {
    darkMode(val) {
      document.documentElement.setAttribute('class', val ? 'dark' : '')
    },
  },
}
</script>

<template>
  <div id='app'>
    <el-config-provider :locale='locale'>
      <router-view />
    </el-config-provider>
  </div>
</template>

<style lang='scss'>
#app {
  height: 100%;
}
</style>
